import { createContext } from '@gluestack-ui/utils';
export const [TextareaProvider, useTextarea] = createContext('TextareaContext');
